import { useSelector } from "react-redux";

import { RootState } from "../store/store";

// Hook: resolves the Catalyst-backed site-wide banner flag and its raw HTML/CSS content.
export function useSiteBanner(): { enabled: boolean; html: string } {
  const enabled = useSelector((state: RootState) => state.appConfigs.siteBannerEnabled);
  const html = useSelector((state: RootState) => state.appConfigs.siteBannerHtml);
  return { enabled, html };
}
